import React, { useState, useContext, useEffect, Fragment, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    Col,
    Container,
    Form,
    Row,
    Spinner
} from 'react-bootstrap';

import AuthContext from '../../../Context/authContext';
import { addSpot } from '../../../Services/api';
import { spotCategoryMapping } from '../constants';
import COUNTRY_STATES_MAPPING from 'src/Pages/account/countries';
import Notification, { useNotification } from 'src/Components/Notification';
import './style.scss';


const NewSpotPage = () => {
    const [name, setName] = useState('');
    const [category, setCategory] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [addressStreetNo, setAddressStreetNo] = useState('');
    const [addressCity, setAddressCity] = useState('');
    const [addressCountry, setAddressCountry] = useState('');
    const [addressState, setAddressState] = useState('');
    const [desc, setDesc] = useState('');
    const [spotImgs, setSpotimgs] = useState([]);
    const [opens, setOpens] = useState('');
    const [closes, setCloses] = useState('');
    const [regNum, setRegNum] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const { setIsAdmin } = useContext(AuthContext);
    const { notifySuccess, notifyError, onClose, notification } = useNotification();

    useEffect(() => {
        setIsAdmin(true);
    }, [setIsAdmin]);

    const states = useMemo(() => {
        if (!addressCountry) { return [] }
        return COUNTRY_STATES_MAPPING[addressCountry]
    }, [addressCountry])

    const validateForm = () => {
        return (
            name.length > 0 &&
            addressStreetNo.length > 0 &&
            addressCity.length > 0 &&
            addressCountry.length > 0 &&
            addressState.length > 0 &&
            desc.length > 0 &&
            category.length > 0 &&
            opens.length > 0 &&
            closes.length > 0
        );
    };

    const registerSpot = async e => {
        e.preventDefault()
        setIsLoading(true);
        const data = {
            name,
            category,
            address: addressStreetNo,
            city: addressCity,
            state: addressState,
            country: addressCountry,
            description: desc,
            time_of_opening: opens,
            time_of_closing: closes,
            images: spotImgs,
            phone_no: phone,
            email: email,
        };
        let spotData = new FormData();
        Object.entries(data).forEach(
            ([key, value]) => {
                if (key === 'images') {
                    for (let i = 0; i < value.length; i++) {
                        spotData.append('images', value[i]);
                    }
                } else {
                    spotData.append(key, value)
                }
            }
        );
        const res = await addSpot(spotData);

        if (res.status !== 200) {
            const err = res.response.data;
            const errMsg = Object.keys(err).map((key) => {
                return `${[key]}: ${err[key]}`;
            });
            notifyError({ message: errMsg });
            setIsLoading(false);
        } else {
            setIsLoading(false);
            notifySuccess({
                message: (
                    <Fragment>
                        Spot created successfully!
                        <span className="text-decoration-underline ms-2" role="button" onClick={() => navigate(`/spot/${res.data.id}/account`)}>
                            View Spot
                        </span>
                    </Fragment>
                )
            })
        }
    };

    return (
        <Container className='registerSpotContainer'>
            <Notification id="add-spot-notif" onClose={onClose} {...notification} />
            <div className='header mb-5'>
                <h4 className='text-secondary'>Register your Spot</h4>
                <p className='text-muted'>
                    Let's get you started with adding your business on Jamlyf
                </p>
            </div>
            <Form onSubmit={registerSpot}>
                <Row className='mb-5'>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formName'>
                            <Form.Control
                                autoFocus
                                className='formInput text-dark'
                                type='text'
                                placeholder='Name'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formCategory'>
                            <Form.Select
                                className='formInput text-dark'
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                <option>Select a category</option>
                                <option value={spotCategoryMapping.BAR}>Bar</option>
                                <option value={spotCategoryMapping.CLUB}>Club</option>
                                <option value={spotCategoryMapping.RESTAURANT}>Restaurant</option>
                                <option value={spotCategoryMapping.LOUNGE}>Lounge</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mb-5'>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formPhoneNo'>
                            <Form.Control
                                className='formInput text-dark'
                                type="tel" 
                                inputMode="numeric" 
                                placeholder='Phone no'
                                vlaue={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formBasicEmail'>
                            <Form.Control
                                className='formInput text-dark'
                                type='email'
                                placeholder='Email'
                                vlaue={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mb-5'>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formOpens'>
                            <Form.Control
                                className='formInput text-dark'
                                type='text'
                                placeholder='Time of Opening. e.g. 10am'
                                vlaue={phone}
                                onChange={(e) => setOpens(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formCLoses'>
                            <Form.Control
                                className='formInput text-dark'
                                type='text'
                                placeholder='Time of Closing e.g 11pm'
                                vlaue={email}
                                onChange={(e) => setCloses(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mb-5' id='addressStreetCity'>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formStreetNo'>
                            <Form.Control
                                className='formInput text-dark'
                                type='text'
                                placeholder='Number, Street Name'
                                value={addressStreetNo}
                                onChange={(e) => setAddressStreetNo(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formCity'>
                            <Form.Control
                                className='formInput text-dark'
                                type='text'
                                placeholder='City'
                                value={addressCity}
                                onChange={(e) => setAddressCity(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mb-5' id='addressStateCountry'>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formCountry'>
                            <Form.Select
                                className='formInput text-dark'
                                onChange={(e) => setAddressCountry(e.target.value)}
                            >
                                <option>Select Country</option>
                                <option>Nigeria</option>
                                <option>United States</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formState' key={addressCountry}>
                            <Form.Select
                                className='formInput text-dark'
                                onChange={(e) => setAddressState(e.target.value)}
                            >
                                <option>Select State</option>
                                {!!states && states.map((country_state) => (<option key={country_state}>{country_state}</option>))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mb-5'>
                    <Col>
                        <Form.Group controlId='formDesc'>
                            <Form.Control
                                className='formInput text-dark'
                                placeholder='Short Description/Tag line of your business'
                                as='textarea'
                                value={desc}
                                onChange={(e) => setDesc(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formRegNum'>
                            <Form.Control
                                autoFocus
                                className='formInput text-dark'
                                type='text'
                                placeholder='Company Registration Number'
                                value={regNum}
                                onChange={(e) => setRegNum(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Form.Group controlId='formFile' className='mb-3'>
                            <Form.Control
                                multiple
                                type='file'
                                className='formInput text-dark custom-file-input'
                                onChange={(e) => setSpotimgs(e.target.files)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <div className='text-center'>
                    <Button
                        className='business col-12 col-lg-6 mt-5'
                        type='submit'
                        disabled={!validateForm() || isLoading}
                    >
                        {isLoading && (
                            <Spinner
                                as='span'
                                animation='border'
                                size='sm'
                                role='status'
                                aria-hidden='true'
                            />
                        )}
                        Submit
                    </Button>
                </div>
                <div className='text-center'>
                    <Button
                        className='cancelButton col-12 col-lg-6 mt-3'
                        type='button'
                        onClick={() => navigate('/dashboard')}
                    >
                        Cancel
                    </Button>
                </div>
            </Form>
        </Container>

    );
};

export default NewSpotPage;
